import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import Footer from './components/footer/Footer'
import Header from './components/header/'
import configureStore from './app/redux/store'
import Container from './app/Container'
import http from './services/api'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import Config from "./auth/Config";
import ReceiveFromTnAccountContainer from "./auth/ReceiveFromTnAccount";
import {getSessionOauthPath} from "./helpers/util";
import "./index.css";

const container = new Container({
  http: http()
})

const reduxStore = configureStore(container)

if (typeof document.getElementById('header-react') !== 'undefined' && document.getElementById('header-react') !== null) {
  ReactDOM.render(
    <Provider store={reduxStore}>
      <Router>
        <Header />
        <Switch>
          <Route path={getSessionOauthPath(Config.prefixUrl)}>
            <ReceiveFromTnAccountContainer />
          </Route>
        </Switch>
      </Router>
    </Provider>,
    document.getElementById('header-react'))
}

if (typeof document.getElementById('footer-react') !== 'undefined' && document.getElementById('footer-react') !== null) {
  ReactDOM.render(
    <Provider store={reduxStore}>
      <Footer/>
    </Provider>,
    document.getElementById('footer-react'))
}
